import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { AssetCollection } from "./asset-labels";

interface ActiveAsset {
  id: string;
  name: string;
  openspaceLink: string | null;
  collection: AssetCollection;
}

interface ActiveAssetState {
  activeAsset: ActiveAsset | null;
}

const initialState: ActiveAssetState = { activeAsset: null };

export const activeAssetSlice = createSlice({
  name: "activeAsset",
  initialState,
  reducers: {
    setActiveAsset: (state, { payload }: PayloadAction<ActiveAsset>) => {
      state.activeAsset = payload;
    },
  },
});

export default activeAssetSlice.reducer;
export const { setActiveAsset } = activeAssetSlice.actions;
export function selectActiveAsset(state: {
  activeAsset: ActiveAssetState;
}): ActiveAsset | null {
  return state.activeAsset.activeAsset;
}
export type { ActiveAsset };
